module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue7.338e0128.jpg";